<template>
	<li>
		<div v-if="!file.uploaded" class="file-upload-progress" :style="getProgressStyle"></div>
		<div v-if="file.uploaded" class="file-upload-copy">
			<span :title="copyText" @click.prevent="copied" class="clipboard" :data-clipboard-text="file.link"></span>
		</div>
		<a v-if="file.uploaded && !rename" class="cdn-link" :href=file.link>{{file.name}}</a>
		<div v-if="!file.uploaded && !rename" class="file-name">{{file.name}} <a v-if="!file.uploaded && !isUploading" :style="underline" href="#" @click.prevent="removeFile(file.name)">(remove)</a></div>
		<div v-if="rename" class="rename-wrapper"><input ref="renameInput" type="text" :value="file.name" @keyup.enter="renameFile"/><button @click.prevent="renameFile">OK</button></div>
		<div v-if="file.exists && !file.uploaded && !isUploading" class="exists">
			<small>This file name already exists at <strong>{{path}}</strong>. Please rename by clicking <a href="#" :style="underline" @click.prevent="showRenameForm">here.</a></small>
		</div>
	</li>
</template>

<script>
    import ClipboardJS from 'clipboard';

	export default {
		data: function() {
            return {
                rename: false,
                copyText: "Click to copy",
                path: this.container + this.folderPath,
                progressStyle: { width: "0%" },
                underline: { "text-decoration": "underline" }
            };
        },
        props: ["file", "container", "folderPath", "bus"],
        created: function() {
            var clipboard = new ClipboardJS("span.clipboard");
        },
        computed: {
            getProgressStyle: function() {

                this.progressStyle.width = this.file.progress + "%";

                return this.progressStyle;
            },
            getUploadedStyle: function() {
                if (this.file.uploaded) {
                    return this.underline;
                }
                return "";
            },

            isUploading: function() {
                return this.file.progress > 0;
            }
        },
        methods: {
            showRenameForm: function() {
                this.rename = true;
            },
            renameFile: function(e) {
                var oldName = this.file.name;
                this.file.name = this.$refs.renameInput.value;
                if (oldName === this.file.name) {
                    this.rename = false;
                    return;
                }
                this.bus.emit("fileRename", oldName, this.$refs.renameInput.value);
                this.rename = false;
            },
            copied: function() {
                this.copyText = "Copied";
            },
            removeFile: function(name) {
                this.bus.emit("fileRemove", name);
            }
        }
	}
</script>